module.exports = __webpack_public_path__ + "img/lg_ring_y_0_null_null@2x.29b6a8f2.png";